import { FC } from 'react';
import { ChecklistDocumentTabs } from '~/common/pages/Compliance/components/ChecklistDocumentTabs';
import { ComplianceDocumentSummary } from './types';

interface DocumentTabsProps {
  /** The documents under the active checklist item. */
  docs: ComplianceDocumentSummary[];
  selectedDocumentId?: string;
  /**
   * Live per-document count of items still needing attention (non-ignored
   * suggestions + open checklist issues), keyed by ingestion document id. Drives
   * the warning icon + count badge so the agent's in-session ignores update them
   * immediately. Falls back to the server `openSuggestionCount` when absent.
   */
  suggestionCounts: Record<string, number>;
  onSelectDocument: (ingestionDocumentId: string) => void;
}

/**
 * Center tab strip: one tab per ingestion document under the active checklist
 * item. Thin wrapper over the shared {@link ChecklistDocumentTabs} that maps the
 * agent-review document summaries (and live, ignore-aware suggestion counts)
 * onto the shared tab shape.
 */
export const DocumentTabs: FC<DocumentTabsProps> = ({
  docs,
  selectedDocumentId,
  suggestionCounts,
  onSelectDocument,
}) => (
  <ChecklistDocumentTabs
    selectedDocumentId={selectedDocumentId}
    tabs={docs.map((doc) => ({
      id: doc.ingestionDocumentId,
      documentName: doc.documentName,
      // Live (ignore-aware) count wins; fall back to the server count until the
      // per-tab detail loads.
      warningCount:
        suggestionCounts[doc.ingestionDocumentId] ?? doc.openSuggestionCount,
    }))}
    onSelectDocument={onSelectDocument}
  />
);
